// src/components/partials/LoginPromptToast/LoginPromptToast.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import LoginPromptToastStyles from './style/LoginPromptToast.module.css'; 

const LoginPromptToast = ({ closeToast, signInRedirect, navigate }) => {
  const { t } = useTranslation();

  return (
    <div className={LoginPromptToastStyles.toastContainer}>
      <div className={LoginPromptToastStyles.textWrapper}>
        <p className={LoginPromptToastStyles.message}>
          {t('LoginPromtToast.required_message')}
        </p>
        {/* 구글 로그인 주의사항 추가 */}
        <p className={LoginPromptToastStyles.subMessage}>
          {t('LoginPromtToast.google_notice')}
        </p>
      </div>
      
      {/* 만약 토스트 안에 바로 로그인 버튼을 넣고 싶다면 아래처럼 활용 가능합니다 */}
      {/* {signInRedirect && (
        <button 
          className={LoginPromptToastStyles.miniLoginButton}
          onClick={() => signInRedirect()}
        >
          로그인
        </button>
      )} */}
    </div>
  );
};

export default LoginPromptToast;